// extracted by mini-css-extract-plugin
export var askAiIcon = "_q5-9";
export var container = "_q5-0";
export var groupSeparator = "_q5-a";
export var highlight = "_q5-4";
export var resultIcon = "_q5-5";
export var resultItem = "_q5-7";
export var resultSubtitle = "_q5-3";
export var resultTitle = "_q5-2";
export var resultsList = "_q5-1";
export var searchGroup = "_q5-6";
export var selected = "_q5-8";